module.exports = __webpack_public_path__ + "img/hand.a7a5220a.png";